{
  "de": {
    "title": {
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "home": "Startseite",
      "ships": {
        "index": "Schiffe",
        "viewer": "Schiff Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Bilder",
      "shipVideos": "%{name} Videos",
      "shipViewer": "%{name} Viewer",
      "images": "Bilder",
      "stats": "Statistiken",
      "login": "Anmelden",
      "signUp": "Registrieren",
      "embed": "Widget Einbetten",
      "apiV1": "API V1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginierung",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "hangar": {
        "index": "Mein Hangar",
        "preview": "Mein Hangar Vorschau",
        "stats": "Meine Hangar Statistiken",
        "import": "Importieren",
        "public": "%{user} Hangar",
        "publicStats": "%{user} Hangar Statistiken",
        "wishlist": "Wunschliste",
        "publicWishlist": "%{user} Wunschliste"
      },
      "requestPassword": "Passwort anfordern",
      "changePassword": "Passwort ändern",
      "fleets": {
        "add": "Neue Flotte erstellen",
        "preview": "Flotten Vorschau",
        "invites": "Flotten Einladungen",
        "members": {
          "index": "%{fleet} Mitglieder",
          "invites": "%{fleet} Einladungen",
          "worldmap": "%{fleet} Mitglieder-Weltkarte",
          "starmap": "%{fleet} Mitglieder-Sternenkarte"
        },
        "stats": "%{fleet} Statistiken",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories"
        },
        "settings": {
          "index": "%{fleet} Einstellungen",
          "fleet": "%{fleet} Einstellungen",
          "membership": "%{fleet} Mitgliedschaft",
          "roles": "%{fleet} Rollen"
        }
      },
      "roadmap": {
        "index": "Roadmap",
        "ships": "Schiff-Roadmap",
        "changes": "Roadmap Änderungen"
      },
      "settings": {
        "index": "Profil Einstellungen",
        "profile": "Profileinstellungen",
        "account": "Konto",
        "hangar": "Hangar Einstellungen",
        "features": "Feature-Flags",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Anwendungen",
        "notifications": "Benachrichtigungseinstellungen",
        "security": "Konto Sicherheit",
        "twoFactor": {
          "enable": "Zwei-Faktor-Authentifizierung aktivieren",
          "disable": "Zwei-Faktor-Authentifizierung deaktivieren",
          "backupCodes": "Zwei-Faktor-Backup-Codes generieren"
        }
      },
      "compare": {
        "ships": "Schiffe vergleichen"
      },
      "notFound": "404",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtgitter"
      },
      "impressum": "Impressum",
      "privacyPolicy": "Datenschutzrichtlinie",
      "cookiePolicy": "Cookie-Richtlinie",
      "visualTests": {
        "index": "Visuelle Tests",
        "panels": "Panels - Visuelle Tests",
        "buttons": "Buttons - Visuelle Tests",
        "tables": "Tabellen - Visuelle Tests",
        "notifications": "Benachrichtigungen - Visuelle Tests",
        "syncModal": "Sync-Modal - Visuelle Tests",
        "supportHint": "Support-Hinweis - Visuelle Tests"
      },
      "admin": {
        "models": {
          "index": "Modelle",
          "new": "Neues Modell",
          "edit": {
            "index": "Modell bearbeiten",
            "metrics": "Modell Metriken bearbeiten",
            "prices": "Modell Preise bearbeiten",
            "fleetchart": "Modell Flottendiagramm-Bilder bearbeiten",
            "hardpoints": "Modell Hardpoints bearbeiten",
            "cargoAndFuel": "Fracht und Treibstoff",
            "cargoHolds": "%{manufacturer} %{model} Frachträume bearbeiten",
            "docks": "Modell Docks bearbeiten",
            "modules": "Modell Module bearbeiten",
            "paints": "Modell Lackierungen bearbeiten",
            "images": "Modell Bilder bearbeiten",
            "videos": "Modell Videos bearbeiten",
            "loaners": "Modell Leihgaben bearbeiten",
            "snubCrafts": "Modell Snub Crafts bearbeiten",
            "upgrades": "Modell Upgrades bearbeiten",
            "packages": "Modell Pakete bearbeiten"
          }
        },
        "components": {
          "index": "Komponenten",
          "new": "Neue Komponente",
          "edit": {
            "index": "Komponente bearbeiten",
            "prices": "Komponente Preise bearbeiten"
          }
        },
        "manufacturers": {
          "index": "Hersteller",
          "new": "Neuer Hersteller",
          "edit": "Hersteller bearbeiten"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Benutzer bearbeiten"
        },
        "vehicles": {
          "index": "Fahrzeuge",
          "edit": "Fahrzeug bearbeiten"
        },
        "admins": {
          "index": "Administratoren",
          "edit": "Admin bearbeiten"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Flotte bearbeiten",
          "memberEdit": "Flottenmitglied bearbeiten"
        },
        "oauthApplications": {
          "index": "OAuth-Anwendungen",
          "new": "Neue OAuth-Anwendung",
          "edit": "OAuth-Anwendung bearbeiten"
        },
        "features": {
          "index": "Feature-Flags",
          "show": "Funktionsdetails"
        },
        "images": {
          "index": "Bilder"
        },
        "maintenance": {
          "index": "Wartung",
          "pghero": "PgHero",
          "features": "Funktionen",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Aufgaben",
          "imports": "Importe",
          "importDetail": "Import-Details",
          "rsiApiStatus": "RSI-API-Status"
        },
        "modelPaints": {
          "index": "Modell Lackierungen",
          "edit": "Modell Lackierung bearbeiten"
        },
        "modelModules": {
          "index": "Modell Module",
          "edit": {
            "index": "%{name} Basisdaten bearbeiten",
            "models": "%{name} Modelle bearbeiten",
            "prices": "%{name} Preise bearbeiten"
          }
        },
        "modelModulePackages": {
          "index": "Modell Modul Pakete"
        }
      }
    }
  }
}
